import { Box, Chip } from '@mui/material';
import { Visibility, InfoOutline } from "@mui/icons-material";

import { MetaDrivenTable, PaginationControls } from '../../../shared/components';
import { useNavigation } from '../../../hooks/useNavigation';

export const TableView: React.FC<{ taskData: any[]; setDetails: React.Dispatch<React.SetStateAction<{ open: boolean; taskId: string | null }>>; pagination: { total: number; limit: number; page: number; }; changeRowsPerPage: (rowsPerPage: number) => void; changePage: (page: number) => void; }> = ({ taskData, setDetails, pagination, changeRowsPerPage, changePage }) => {

    const { goToRecurringTasks, goToSchedulePlanning, goToStageGates, goToRiskDashboard, goToQueries, goToMeetingDetails } = useNavigation();

    const headers = [
        { "alias_name": "task_name", "label": "Task Name", "display_order": 0, is_show: true },
        { "alias_name": "programme_name", "label": "Programme", "display_order": 1, is_show: true },
        { "alias_name": "portfolio_name", "label": "Portfolio", "display_order": 2, is_show: true },
        { "alias_name": "project_title", "label": "Project Title", "display_order": 3, is_show: true },
        { "alias_name": "description", "label": "Description", "display_order": 4, is_show: true },
        { "alias_name": "category_display_text", "label": "Category", "display_order": 5, is_show: true },
        { "alias_name": "owner", "label": "Action Owner", "display_order": 8, is_show: true },
        { "alias_name": "assigned_to", "label": "Assigned To", "display_order": 9, is_show: true },
        { "alias_name": "due_date", "label": "Due Date", "display_order": 10, is_show: true },
        { "alias_name": "completed_at", "label": "Completed Date", "display_order": 11, is_show: true },
        { "alias_name": "priority_display_text", "label": "Priority", "display_order": 14, is_show: true },
        { "alias_name": "status_display_text", "label": "Status", "display_order": 15, is_show: true },
    ];

    const metrics = {
        due_date: {
            type: 'date'
        },
        completed_at: {
            type: 'date'
        },
        target_date: {
            type: 'date'
        },
        tags_display_text: {
            type: 'component',
            element: ((row: { tags: String[] }) => (
                <>
                    {row.tags.length === 0 ? 'No Tags Assigned' : row.tags.map((tag, index) => (
                        <Chip key={index} label={tag} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                    ))}
                </>
            ))
        }
    };

    const handleNavigate = (row: { object_type: "recurring_task" | "stage_gate" | "checklist" | "activity" | "risk" | "queries" | "meeting", project_id: number | null, programme_id: number | null, portfolio_id: number | null, object_id: number, project_title: string }) => {
        if (row.object_type === "recurring_task" && row.project_id) {
            goToRecurringTasks({ projectId: row.project_id, projectName: row.project_title });
        } else if ((row.object_type === "stage_gate" || row.object_type === "activity") && row.project_id) {
            goToSchedulePlanning({ projectId: row.project_id, projectName: row.project_title, objectId: row.object_id, type: row.object_type === "stage_gate" ? 'stageGate' : 'activity' });
        } else if (row.object_type === 'checklist' && row.project_id) {
            goToStageGates({ projectId: row.project_id, projectName: row.project_title, objectId: row.object_id });
        } else if (row.object_type === 'risk') {
            goToRiskDashboard({ id: String(row.object_id) });
        } else if (row.object_type === 'queries') {
            goToQueries(row.object_id);
        } else if (row.object_type === 'meeting') {
            goToMeetingDetails(row.object_id);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                overflow: 'hidden',
            }}
        >
            <MetaDrivenTable
                headers={headers}
                data={taskData}
                dataMetrics={metrics}
                actions={[
                    {
                        label: <InfoOutline />,
                        handleClick: (row: any) => {
                            setDetails({ open: true, taskId: row.task_id });
                        }
                    },
                    {
                        label: <Visibility />,
                        handleClick: (row: any) => {
                            handleNavigate(row)
                        }
                    },
                ]}
                sortDisabled
            />
            <PaginationControls
                total={pagination.total}
                rowsPerPage={pagination.limit}
                currentPage={pagination.page}
                handleRowsPerPage={changeRowsPerPage}
                handlePageChange={changePage}
            />
        </Box>
    );
};